"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.variationMap = void 0;
var RadioTabProps_1 = require("./RadioTabProps");
var styles = require("./RadioTab.css");
exports.variationMap = new Map([
    [RadioTabProps_1.RadioTabsVariations.TAB_A, styles.tabA],
    [RadioTabProps_1.RadioTabsVariations.TAB_B, styles.tabB],
    [RadioTabProps_1.RadioTabsVariations.TAB_C, styles.tabC],
    [RadioTabProps_1.RadioTabsVariations.TAB_D, styles.tabD],
    [RadioTabProps_1.RadioTabsVariations.TAB_Invalid, styles.tabInvalid],
]);
//# sourceMappingURL=RadioTabStylesMap.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tabs/components/RadioTab/RadioTabStylesMap.js
// module id = 1271
// module chunks = 8